import React from "react"
import {Icon, IconType} from "components/Icon"
import styles from "./StatisticCards.module.css"
import cx from "classnames"

type StatisticCardItemProps = {
    icon: IconType
    className?: string
    title: string
    value1: string
    value2: string
    value1ClassName?: string
    value2ClassName?: string
}

const StatisticCardItem: React.FC<StatisticCardItemProps> = ({
    icon,
    className,
    title,
    value1,
    value2,
    value1ClassName,
    value2ClassName
}) => {
    return (
        <div className={styles.cardItem}>
            <div className={styles.cardItem__header}>
                <div className={cx(styles.cardItem__icon__container, className)}>
                    <Icon icon={icon} className={styles.cardItem__icon} />
                </div>

                <div className={styles.cardItem__title}>{title}</div>
            </div>

            <div className={styles.cardItem__body}>
                <div className={cx(styles.cardItem__value1, value1ClassName)}>{value1}</div>
                <div className={cx(styles.cardItem__value2, value2ClassName)}>{value2}</div>
            </div>
        </div>
    )
}

export default StatisticCardItem
